import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CiiBadgeComponent } from '../../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-tma-angular',
  standalone: true,
  imports: [RouterLink, CiiBadgeComponent],
  templateUrl: './tma-angular.component.html',
  styleUrl: './tma-angular.component.css'
})
export class TmaAngularComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("TMA Angular & RxJS : Maintenance Frontend Expert — Agréée CII");
    this.metaService.updateTag({ name: 'description', content: "Maintenance TMA Angular corrective et évolutive. Experts RxJS, Signals et performance (Core Web Vitals). Sécurisez vos interfaces critiques avec notre TMA éligible au CII." });
  }
}